import React from 'react'

const PublicProfileView = () => {
  return (
    <div>PublicProfileView</div>
  )
}

export default PublicProfileView